import { Permission } from '@bookora/shared';

import { usePlanLock } from '@/features/plan/plan-access';
import { useCan } from '@/permissions/use-can';

/**
 * The hub section is offered to whoever may manage integrations, and only
 * while the plan includes API access (a locked feature is advertised by the
 * plan screens, not by the help hub).
 */
export function useIntegrationsHubVisible(): boolean {
  const can = useCan(Permission.SETTINGS_INTEGRATIONS);
  const lock = usePlanLock('apiAccess');
  return can && lock.state === 'open';
}
